var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinklogoblack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 26,
    viewBox: "0 0 100 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6267 4.23193H32.1592V21.7679H48.2386V19.8439H34.6267V4.23193Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.186 4.23193H50.7119V21.7658H53.186V4.23193Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3984 4.23193V21.7679H58.8638V6.9516L73.8829 21.7679H76.5686V4.23193H74.1032V19.0738L59.058 4.23193H56.3984Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.925 10.2045L99.2382 4.23193H95.9373L82.2447 15.6439V4.23193H79.7793V21.7679H82.2447V18.035L90.0858 11.6486L97.0303 21.7679H99.9996L91.925 10.2045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7383 25.9999V24.7904H14.447C12.2504 24.794 10.1192 24.0598 8.41016 22.7107C10.1119 24.72 12.0231 25.9999 15.5597 25.9999H24.7383Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7391 23.5812V22.3717H12.8399C10.5928 22.3717 8.28447 21.591 6.67871 20.292C8.38047 22.3013 10.1695 23.5812 13.7039 23.5812H24.7391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7385 21.1622V19.9528H10.9936C8.83477 19.956 6.74296 19.2202 5.08105 17.873C6.78281 19.8824 8.57184 21.1622 12.1063 21.1622H24.7385Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65716 17.5338V0H7.41793V15.4178C7.41735 16.0756 7.46914 16.7325 7.57284 17.3824C7.23708 17.3211 6.90497 17.2421 6.57796 17.1456C6.31573 16.2087 6.18364 15.2416 6.18525 14.2702V0H4.94821V13.1205C4.94651 14.3894 5.19235 15.6469 5.67254 16.8257C5.38673 16.7062 5.10965 16.5761 4.83912 16.431C4.09515 15.0577 3.70709 13.527 3.70898 11.9729V0H2.47411V10.8232C2.47116 12.6567 3.02717 14.4494 4.07115 15.9724C2.84385 14.8978 1.96043 13.4993 1.52724 11.9452C1.33368 11.2028 1.23619 10.4396 1.23707 9.67348V0H2.21984e-05V8.46616C-0.00214246 9.43063 0.154019 10.3892 0.462551 11.3053C1.28507 13.833 3.12209 15.8423 5.2362 17.1328C6.7192 18.1391 8.47138 18.6983 10.276 18.7412H24.7409V17.5338H8.65716Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinklogoblack);
export default __webpack_public_path__ + "static/media/linklogoblack.32baabd54fe4dbfdd38567cec6162085.svg";
export { ForwardRef as ReactComponent };